
<div class="modal fade" id="labShipmentModal" tabindex="-1" role="dialog" aria-labelledby="viewImage" aria-hidden="true">
  <div class="modal-dialog  modal-xl" role="document">
    <div class="modal-content">
      <button class="no-border-btn doc-close-btn" data-dismiss="modal">
        <img src="../../../assets/images/cross-icon-3.svg" alt="cross-icon" width="24px" height="24px">
      </button>
      <div class="modal-header">
        <div class="row">
          <div class="col-12">
            ID: {{selectedShipment.shipmentId}}
          </div>
        </div>
      </div>
      <div class="modal-body" style="position: relative;">
        <div class="row">
          <div class="col-12">
            <table class="table">
                <tbody>
                    <tr style="background:transparent !important;cursor: initial !important;"
                    *ngIf="selectedShipment.flag">
                      <td colspan="4" class="height-240" style="position:relative;border:none;">
                        <div class="row">
                          <div class="col-6 stroke-right" style="border-right: 2px solid rgba(61, 72, 86, 0.30);"
                          *ngIf="selectedShipment.shipmentDetails">
                            <div class="details-1-card">
                              <div class="row auto-height-41">
                                <div class="col-6 left">Date of creation:</div>
                                <div class="col-6 right" *ngIf="selectedShipment.shipmentDetails.dateShipmentCreation">
                                  {{selectedShipment.shipmentDetails.dateShipmentCreation|date:'dd/MM/yyyy'}}
                                </div>
                                <div class="col-6 right" *ngIf="!selectedShipment.shipmentDetails.dateShipmentCreation">-</div>
                              </div>
                              <div class="row auto-height-41">
                                <div class="col-6 left">Created by:</div>
                                <div class="col-6 right">{{selectedShipment.shipmentDetails.adminName}}</div>
                              </div>
                              <div class="row auto-height-41">
                                <div class="col-6 left">Location:</div>
                                <div class="col-6 right">{{selectedShipment.shipmentDetails.shippedFromName_tag}}</div>
                              </div>
                              <div class="row auto-height-41">
                                <div class="col-6 left">To:</div>
                                <div class="col-6 right">{{selectedShipment.shipmentDetails.shippedToName_tag}}</div>
                              </div>
                            </div>
                          </div>
                          <div class="col-6" style="max-height: 300px; overflow-y: auto;">
                            <table class="table inner-table">
                              <thead style="border: 1px solid rgba(61, 72, 86, 0.30);">
                                <tr>
                                  <th scope="col" style="max-width: 80px; min-width: 60px;">Sample type</th>
                                  <th scope="col" style="max-width: 50px; min-width: 50px;">Quantity</th>
                                  <th scope="col">Sample IDs</th>
                                </tr>
                              </thead>
                              <tbody style="border: 1px solid rgba(61, 72, 86, 0.30);">
                                <ng-container *ngIf="selectedShipment.shipmentDetails && 
                                selectedShipment.shipmentDetails.sampleDetails">
                                  <tr *ngFor="let task of selectedShipment.shipmentDetails.sampleDetails">
                                    <td style="max-width: 80px; min-width: 60px;">{{task.sampleIdType}}</td>
                                    <td style="max-width: 50px; min-width: 50px;">{{task.count}}</td>
                                    <td style="line-break:anywhere;overflow: initial;white-space: initial;">{{task.sampleIds}}</td>
                                  </tr>
                                </ng-container>
                                <tr *ngIf="selectedShipment.shipmentDetails && 
                                selectedShipment.shipmentDetails.sampleDetails && selectedShipment.shipmentDetails.sampleDetails.length == 0">
                                  <td colspan="3">There is no shipment details</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </td>
                    </tr>
                </tbody>
            </table>
          </div>
        </div>
        <div class="row stick-bottom">
          <div class="col">
            <button class="btn-1 no-border-btn" type="button" 
            (click)="downloadCsv()" style="width: 150px;">
              Download CSV
            </button>
          </div>
          <div class="col-auto ml-auto">
            <button class="btn-1 solid-btn" type="button" 
            (click)="exportShipmentPDf()">
              Print
            </button>
          </div>
        </div>
      </div>
      <div class="modal-footer" style="position: absolute; bottom: 0px; right: 0px;">
        <div class="row">
          <div class="col-auto ml-auto">
            <div class="content-center">
              <!-- <button class="btn-1 circle-btn red-border"  data-dismiss="modal" style="width:32px; height:32px" (click)="onRejectDoc()"
              [disabled]="!editAccess">
                <img src="../../../assets/images/cross-icon.svg" alt="cross-icon" width="21px" height="21px">
              </button>
              <button class="btn-1 ml-24 circle-btn green-border" data-dismiss="modal" style="width:32px; height:32px" (click)="onAcceptDoc()"
              [disabled]="!editAccess">
                <img src="../../../assets/images/tick-icon.svg" alt="tick-icon" width="21px" height="21px">
              </button> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>